export default __webpack_public_path__ + "static/media/deligoo-sm.24085f78.svg";